import {RaEvent, RaEventType} from "./RaEvent";

export enum PIPELINE_STATUS {
    manual = 0,
    script = 1,
    batch = 2,
    selectionUpdated = 3,
    pronunciations = 4
}

export class PipelineEvent extends RaEvent {

    static TYPE:RaEventType = "pipeline_event";

    constructor(private _status:PIPELINE_STATUS) {
        super(PipelineEvent.TYPE);
        console.log("creating pipeline event with status" + this._status);
    }

    public get status():PIPELINE_STATUS{
        console.log("returning status: " + this._status);
        return this._status;
    }
}
